import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppPopupEvaluationPage } from './app-popup-evaluation';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppPopupEvaluationPage,
  ],
  imports: [
    IonicPageModule.forChild(AppPopupEvaluationPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppPopupEvaluationPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-popup-evaluation/app-popup-evaluation.module.ts